
                            module.exports = function( bundle ) {
                                var loader = require( "./loader-d20feded5cd4b4e8741163e1095849df.js" );
                                return loader( bundle );
                            };
                        